module.exports = __webpack_public_path__ + "static/media/price_grey.63b4bc66.svg";